// extracted by mini-css-extract-plugin
export default {"root":"DropdownMenu_root__hLi8Z","footer":"DropdownMenu_footer__7dK19"};